"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = require("../form-definition");
var condition_reducer_1 = require("./condition.reducer");
var action_reducer_1 = require("./action.reducer");
/**
 * This function takes an initial form state, including: the starting form, the current responses, and any previously existing response information,
 * and processes it based on the set of rules on the form.
 * - First, it checks to see if any preconditions exist on the form and runs those through the actionReducer if any are present.
 * - Second, the rules are run through the rulesReducer to produce the final state
 * - Finally, the modified FormState is returned to the user
 * @param {FormState} formState the initial FormState before the rules are applied (see ../common/form-definition for information on the FormState structure)
 */
function runRulesEngine(formState) {
    var rules = formState.getIn(['form', 'rules']);
    if (!rules) {
        return formState;
    }
    var state = new form_definition_1.FormState(formState);
    // run preconditions
    rules.forEach(function (rule) {
        var preConditionActions = rule.preConditionActions;
        preConditionActions && preConditionActions.forEach(function (action) {
            if (actionIsTiedToSupportedFieldType(formState, action)) {
                state = action_reducer_1.actionReducer(state, action);
            }
        });
    });
    rules.forEach(function (rule) {
        state = ruleReducer(state, rule);
    });
    state = filterHiddenValues(state);
    return state;
}
exports.runRulesEngine = runRulesEngine;
/**
 * This function applies a given rule to the state.
 * It first checks to see what operation needs to be applied when there are multiple conditions to check(And/Or)
 * Then it processes the conditions using the conditionReducer, which returns whether or not the conditions for a rule have been met based on the state
 * If the required number of conditions are not met based on the operation type the initial state is returned
 * If the required number of conditions are met then the actionReducer is applied for each conditionAction in the rule
 * @param {FormState} formState the initial FormState before this rule is applied
 * @param {FormRule} rule the rule that is to be applied to the state
 */
function ruleReducer(formState, rule) {
    var disabled = rule.disabled, condition = rule.condition, conditionActions = rule.conditionActions;
    if (disabled || !form_definition_1.formRuleTypes.isRuleSupported(rule)) {
        return formState;
    }
    var conditionsMet = condition_reducer_1.conditionReducer(formState, condition);
    if (conditionsMet) {
        var modifiedState = new form_definition_1.FormState(formState);
        conditionActions && conditionActions.forEach(function (action) {
            if (actionIsTiedToSupportedFieldType(formState, action)) {
                modifiedState = action_reducer_1.actionReducer(modifiedState, action);
            }
        });
        return modifiedState;
    }
    return formState;
}
exports.ruleReducer = ruleReducer;
/**
 * This function will remove any values for elements that are marked as hidden, because any responses to these questions should not be included when saving
 * @param {FormState} initialState
 */
function filterHiddenValues(initialState) {
    var form = initialState.form;
    var elements = form.elements;
    var state = initialState;
    elements && elements.forEach(function (element) {
        state = removeHiddenValueRecursive(element, state);
    });
    return state;
}
exports.filterHiddenValues = filterHiddenValues;
/**
 * Handles recursively removing values for hidden fields, including groups
 * @param element the element we are removing a value for
 * @param initialState the form state
 * @param parentHidden true if a parent group element was hidden, causing this element to be hidden
 */
function removeHiddenValueRecursive(element, initialState, parentHidden) {
    if (parentHidden === void 0) { parentHidden = false; }
    var state = initialState;
    if (!element)
        return state;
    var hiddenValue = element.hidden || parentHidden;
    if (element.type === form_definition_1.elementTypes.group) {
        element.subElements && element.subElements.forEach(function (subElement) {
            state = removeHiddenValueRecursive(subElement, state, hiddenValue);
        });
    }
    else {
        var elementValue = state.getIn(['value', element.id]);
        if (!!elementValue && hiddenValue) {
            state = state.setIn(['value', element.id], undefined);
        }
    }
    return state;
}
function actionIsTiedToSupportedFieldType(formState, action) {
    var supportedElements = formState.form.elements.filter(function (immutableFormElement) {
        return immutableFormElement.type !== form_definition_1.elementTypes.unsupported;
    });
    return supportedElements.some(function (el) {
        return el.id == action.elementId ||
            (el.immutableDataFormat &&
                el.immutableDataFormat.otherTextElementId == action.elementId);
    });
}
//# sourceMappingURL=rules-engine.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/rules-engine/rules-engine.js
// module id = 1102
// module chunks = 0